<template>

    <div class="mainLogo" :class="{'mainLogo-white': isWhite}">
        <router-link :to="{name: 'home'}">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 239.664 159.314">
                <path class="mainLogo_path" id="Tracé_18" data-name="Tracé 18" d="M196.571,99.317a16.9,16.9,0,1,1-16.9-16.9,16.9,16.9,0,0,1,16.9,16.9M76.9,60A16.9,16.9,0,1,1,60,43.093,16.9,16.9,0,0,1,76.9,60M239.664,99.317A59.969,59.969,0,0,0,160.84,42.362V0H119.671V53.817A59.995,59.995,0,0,0,0,59.964v99.35H41.169V116.952a59.962,59.962,0,0,0,78.5-50.787V99.35a60,60,0,0,0,119.993-.032"/>
            </svg>
        </router-link>
    </div>

</template>

<script>
    export default {
        name: 'MainLogo',
        props: ['isWhite'],
    };
</script>

<style scoped lang="scss">
    .mainLogo{
        width: 80px;

        path{
            @include transition();
        }

        &-white{
            path{
                fill: #fff;
            }
        }
    }
</style>